<template>
<div>
  <div class="wrap"
       @touchstart.prevent="_touchStart($event)"
       ref="pages">
    <div class="dow-block" ref="down">
       <div class="down-back">
         <img src="../assets/index/index_1.jpg" alt="">
       </div>
       <div class="down-btn">
         <div>
           <img src="../assets/index/index_7.png" alt="">
           <img src="../assets/index/index_8.png" alt="">
         </div>
       </div>
     </div>
    <div class="other-block" ref="block2">
      <img src="../assets/index/index_2.jpg" alt="">
    </div>
    <div class="other-block" ref="block3">
      <img src="../assets/index/index_3.jpg" alt="">
    </div>
    <div  class="other-block last-block">
      <img src="../assets/index/index_4.jpg" alt="">
      <div>
        <p>沪ICP备19011582号-2</p>
        <p>上海极客公社企业发展有限公司</p>
        <p>Shanghai geek commune enterprise development co. LTD</p>
      </div>
    </div>
  </div>
  <div class="footer-down" v-show="down">
    <div>
      <img src="../assets/index/index_5.png" alt="">
      <img src="../assets/index/index_6.png" alt="">
    </div>
  </div>
</div>
</template>

<script>
// import { debounce } from '../common/js/common';

export default {
  name: 'index',
  data() {
    return {
      startY: 0,
      moveY: 0,
      direction: 0, // 0 向上， 1向下
      pageNo: 0, // 第几页
      transformY: 0,
      windowHeight: document.documentElement.clientHeight || document.body.clientHeight,
      isLastPage: false,
      lastPageMoreHeight: false, // 最后一页高度超过屏幕高度
      down: false,
    };
  },
  methods: {
    // 手指进入屏幕位置
    _touchStart(e) {
      e.preventDefault();
      const touch = e.touches ? e.touches[0] : e;
      console.log(e)
      this.startY = touch.clientY;
      window.addEventListener('touchmove', this._touchMove);
      window.addEventListener('touchend', this._touchEnd);
    },
    // 手指拖动
    _touchMove(e) {
      const touch = e.touches ? e.touches[0] : e;
      this.moveY = parseInt(touch.clientY - this.startY);
      const moveY = this.transformY + this.moveY;
      // this.$refs.pages.style.transform = `translate3d(0px, ${moveY}px, 0) scale(1, 1)`;
    },
    // 手指离开
    _touchEnd(e) {
      if (this.moveY < 0) {
        this.isToNextPage();
      } else {
        this.toPrevPage();
      }
      // window.removeEventListener('touchmove', this._touchMove);
      // window.removeEventListener('touchend', this._touchEnd);
    },
    // 是否进入下一页
    isToNextPage() {
      const { pages } = this.$refs;
      const childrens = pages.children;
      const nextPage = childrens[this.pageNo + 1];
      const childNum = childrens.length;

      if (this.lastPageMoreHeight) { // 判断是否是最后一页，且高度大于屏幕高度
        this.transformY = this.windowHeight - pages.clientHeight;
        pages.style.transform = `translate3d(0px, ${this.transformY}px, 0) scale(1, 1)`;
        return false;
      }
      this.transformY = -nextPage.offsetTop;
      if (this.pageNo === (childNum - 2) && nextPage.clientHeight < this.windowHeight) { // 判断最后一页高度是否小于屏幕高度
        this.transformY = this.windowHeight - nextPage.offsetTop - nextPage.clientHeight;
        this.isLastPage = true;
      } else {
        this.transformY = -nextPage.offsetTop;
        if (this.pageNo !== (childNum - 2)) {
          this.pageNo++;
        } else {
          this.lastPageMoreHeight = true;
          this.isLastPage = true;
        }
      }
      this.down = true;
      pages.style.transform = `translate3d(0px, ${this.transformY}px, 0) scale(1, 1)`;
    },
    // 进入上一页
    toPrevPage() {
      this.lastPageMoreHeight = false;
      if (this.isLastPage) {
        this.pageNo++;
        this.isLastPage = false;
      }
      const childrens = this.$refs.pages.children;
      const prevPage = this.pageNo - 1 < 0 ? childrens[0] : childrens[this.pageNo - 1];
      this.transformY = -prevPage.offsetTop;
      this.pageNo = (this.pageNo - 1) < 0 ? 0 : this.pageNo - 1;
      this.down = this.pageNo !== 0;
      this.$refs.pages.style.transform = `translate3d(0px, ${this.transformY}px, 0) scale(1, 1)`;
    },
  },
};
</script>
<style scoped lang="scss">
  .wrap{
    width: 100%;
    box-sizing: border-box;
    transition: 0.5s ease-in;
    .dow-block{
      position: relative;
      width: 100%;
      transition: 0.5s ease-in;
      .down-back{
        img{
          display: block;
          width: 100%;
        }
      }
      .down-btn{
        position: absolute;
        bottom: 200px;
        width: 100%;
        text-align: center;
        div{
          display: inline-block;
          img{
            display: block;
            width: 300px;
            margin: 40px;
          }
        }
      }
    }
    .other-block{
      transition: 0.5s ease-in;
      position: relative;
      img{
        display: block;
        width: 100%;
      }
      div{
        position: absolute;
        bottom: 120px;
        left: 50%;
        transform:translate(-50%,-50%);
        width: 100%;
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        p{
          margin-bottom: 5px;
        }
      }
    }
    .last-block{
      padding-bottom: 120px;
    }
  }
  .footer-down{
    position: fixed;
    z-index: 999;
    width: 100%;
    bottom: 0;
    padding: 30px;
    background-color: rgba(0,0,0,0.6);
    text-align: center;
    box-sizing: border-box;
    div{
      display: inline-block;
      margin: 0 auto;
      img{
        display: inline-block;
        width: 200px;
        margin: 0 70px;
      }
    }
  }
</style>
